/**
 * Features the frontend gates by itself. Everyone sees one until an admin marks it beta on the
 * All Features screen; from then on only audiences that switch it on do. The name must not match
 * a backend feature (the people service refuses it).
 */
export const FRONTEND_FEATURES = {
  /** Paying money through the app: invoice payments, payment links and their approvals. */
  PaymentsUI: 'Payments UI',
} as const;

export type FrontendFeature = (typeof FRONTEND_FEATURES)[keyof typeof FRONTEND_FEATURES];

export const FRONTEND_FEATURE_NAMES: readonly FrontendFeature[] = Object.values(FRONTEND_FEATURES);
